import { api } from "..";

const endpoint = "/api/products";

// PRODUCTS
export const getProductList = (queryParams) => {
  return api.get(`${endpoint}`, { params: queryParams });
};

export const getProductById = (id) => {
  return api.get(`${endpoint}/${id}`);
};

export const addProduct = (data) => {
  return api.post(`${endpoint}`, data);
};

export const updateProduct = (id, data) => {
  return api.put(`${endpoint}/${id}`, data);
};

export const deleteProduct = (id) => {
  return api.delete(`${endpoint}/${id}`);
};

// PRODUCT CATEGORIES
export const getProductCategoryList = (queryParams) => {
  return api.get(`${endpoint}/categories`, { params: queryParams });
};

export const getProductCategoryById = (id) => {
  return api.get(`${endpoint}/categories/${id}`);
};

export const addProductCategory = (data) => {
  return api.post(`${endpoint}/categories`, data);
};

export const updateProductCategory = (id, data) => {
  return api.put(`${endpoint}/categories/${id}`, data);
};

export const deleteProductCategory = (id) => {
  return api.delete(`${endpoint}/categories/${id}`);
};

export const getProductCostHistory = (id) => {
  return api.get(`${endpoint}/${id}/cost-history`);
};
  
